import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl, ControlContainer } from '@angular/forms';
import { Router } from '@angular/router';

import { CartService } from './cart.service';
import { CaseIdentifier } from './../shared/case-identifier';
import { CivilCase } from './../civil/civil-case';
import { CourtCase } from '../shared/court-case';
import { EventService } from './../shared/event.service';
import { HtmlUtil } from './../shared/html-util';
import { FileNumberUtil } from './../shared/file-number-util';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.less']
})
export class CartComponent implements OnInit {
  @ViewChild('discardAllModal') public discardAllModal;

  submitted = false;
  courtCasesFormGroup: FormGroup;

  pleadingShowFlags: boolean[];
  mouseOverCaseFlags: boolean[];
  pleadingHideNotifyFlags: boolean[];
  caseRowSelectedFlags: boolean[];
  caseRowIndexMap: Map<CaseIdentifier, number>;

  constructor(public eventService: EventService,
              public cartService: CartService,
              public formBuilder: FormBuilder,
              private router: Router) { }

  ngOnInit() {
     // set the flags's default values
     this.defineAndSetCaseDefaultDisplayFlags(this.cartService.savedCases);

     this.buildForm();
  }

  hideModal(): void {
    this.router.navigate([{ outlets: { view: null }}]);
  }

  buildForm(): void {
    // TODO: assuming this is a civil case is a problem.
        const casesControlArray = new FormArray(this.cartService.savedCases.map((savedCase: CivilCase, index: number) => {
              return new FormGroup({
                county:     new FormControl(savedCase.getCaseIdentifier().county),
                caseNumber: new FormControl(FileNumberUtil.normalizeCaseNumberWithoutCentury(savedCase.getCaseIdentifier().caseNumber)),
                caseType: new FormControl(savedCase.getCaseTypeDescription()),
                caseIdentifier: new FormControl(savedCase.getCaseIdentifier()),
                caseCaption: new FormControl(savedCase.getCaseCaption()),
                initiatingPleadingAndIssue: new FormControl(savedCase.getInitiatingPleadingAndIssue()),
                caseStatusDescription: new FormControl(savedCase.getCaseStatusDescription()),
                judgmentDocketedAndIndexed: new FormControl(savedCase.getJudgmentDocketedAndIndexed()),
                savedCase: new FormControl(savedCase),
                caseChecked: new FormControl(false),
              });
        }));

     this.courtCasesFormGroup = new FormGroup({
          cases: casesControlArray,
          selectedCases: new FormControl(this.mapCases(casesControlArray.value), Validators.required)
      });

      casesControlArray.valueChanges.subscribe((v) => {
        console.log('values changesd ');
        this.courtCasesFormGroup.controls['selectedCases'].setValue(this.mapCases(v));
      });
  }

  mapCases(cases) {
    const selectedCases = cases.filter((l) => l.caseChecked).map((l) => l.key);
    return selectedCases.length ? selectedCases : null
  }

  getCartContents(): CourtCase[] {
    return this.cartService.savedCases;
  }

  isCaseInCart(caseIdentifier: CaseIdentifier): boolean {
    return this.cartService.contains(caseIdentifier);
  }

  removeCaseFromCart(aCase: CourtCase): void {
    this.cartService.removeCase(aCase);

    // rebuild the form after removing case from cart
    this.buildForm();
  }

  onViewCaseSelected(caseIdentifier: CaseIdentifier): void {
      this.router.navigate(
          [{
              outlets: {
                // tslint:disable-next-line:max-line-length
                view: ['details', caseIdentifier.type, caseIdentifier.county, FileNumberUtil.normalizeCaseNumberWithoutCentury(caseIdentifier.caseNumber), {fromCart: true}]
              }
            }]);
  }

  openEmail(): void {
    this.submitted = true;
    if (!this.cartService.selectedCaseIdentifiers.size && this.courtCasesFormGroup.invalid) {
      return;
    }
    this.eventService.openEmail(this.cartService.getSelectedCases());
    this.submitted = false;
  }

  openPrint(): void {
    this.submitted = true;
    if (!this.cartService.selectedCaseIdentifiers.size && this.courtCasesFormGroup.invalid) {
      return;
    }
    this.eventService.openPrint(this.cartService.getSelectedCases());
    this.submitted = false;
  }

  clearMessages(): void {
    this.submitted = false;
  }

  openDiscardAllInCart(): void {
    this.discardAllModal.show();
  }

  closeDiscardAllInCart(): void {
    this.discardAllModal.hide();
  }

  selectAll(): void {
    // set all checked
    this.caseRowSelectedFlags = new Array(this.cartService.savedCases.length).fill(true);
    for ( let caseItem of this.courtCasesFormGroup.get('cases').value) {
          caseItem.caseChecked =   true;
    }

    // add all cases
    this.cartService.selectAll();

    // reset the selected cases control (used for validator)
    this.courtCasesFormGroup.controls['selectedCases'].setValue(this.mapCases(this.courtCasesFormGroup.controls['cases'].value));
  }

  deselectAll(): void {
    // set all unchecked
    this.caseRowSelectedFlags = new Array(this.cartService.savedCases.length).fill(false);
    for ( let caseItem of this.courtCasesFormGroup.get('cases').value) {
         caseItem.caseChecked = false ;
    }

    // clear all cases
    this.cartService.deselectAll();

    // reset the selected cases control (used for validator)
    this.courtCasesFormGroup.controls['selectedCases'].setValue(this.mapCases(this.courtCasesFormGroup.controls['cases'].value));
  }

  /**
   * @param caseIdentifier
   */
  toggleCaseSelection(caseIdentifier) {
      const caseSelected = this.cartService.isSelected(caseIdentifier);
      if (caseSelected) {
          this.cartService.deselectCase(caseIdentifier);
      } else {
          this.cartService.selectCase(caseIdentifier);
      }

      // set row selected flags
      let selectedIndex = this.caseRowIndexMap.get(caseIdentifier);
      this.caseRowSelectedFlags[selectedIndex] = !caseSelected;
  }

  toggleMassSelection() {
     if (!this.cartService.areAllSelected()) {
       this.selectAll();
     } else {
       this.deselectAll();
     }
  }

  discardAll() {
     this.cartService.empty();
     this.discardAllModal.hide();
     this.hideModal();
  }

  /**
    * listener for click on show button
    * @param i the index of the row (i.e the index of the case)
    */
   showPleading(i: number) {
      this.pleadingShowFlags[i] = true;
   }

   /**
    * listener for click on hide button, which will set the pleadingHideNorifyFlags[i] (i.e. the ith row).
    * @param i the index of the row (i.e the index of the case)
    */
   hidePleading(i: number) {
      this.pleadingHideNotifyFlags[i] = true;
   }

   /**
    * onPleadingClosed event handler
    * @param i the index of the row (i.e the index of the case)
    */
   onPleadingClosed(i: number) {
     this.pleadingHideNotifyFlags[i] = false;
     this.pleadingShowFlags[i] = false;
   }

  /**
    * listener for mouse over the case row
    * @param i  the index of the row (i.e the index of the case)
    */
   onMouseOverCase(i: number) {
     this.mouseOverCaseFlags[i] = true;
   }

   /**
    * listener for mouse off the case row
    * @param i the index of the row (i.e the index of the case)
    */
   onMouseOffCase(i: number) {
      this.mouseOverCaseFlags[i] = false;
   }

   /**
    * set the default display flag values for each case.
    * @param containedCases
    */
   private defineAndSetCaseDefaultDisplayFlags(containedCases: any[]): void {
    if (containedCases && containedCases.length) {
      this.pleadingShowFlags = new Array(containedCases.length).fill(false);
      this.mouseOverCaseFlags = new Array(containedCases.length).fill(false);
      this.pleadingHideNotifyFlags = new Array(containedCases.length).fill(false);
      this.caseRowSelectedFlags = new Array(containedCases.length).fill(false);
      this.caseRowIndexMap = new Map<CaseIdentifier, number>();
      containedCases.forEach((eachCaseItem, index) => {
        this.caseRowIndexMap.set(eachCaseItem.caseIdentifier, index);
      });
    }
  }

  /**
   * To resolve popover flicking issue upon mouse over/leave, hide or not the window scrollbar
   * @param type string
   */
  public popOverHandler(type: string) {
    HtmlUtil.popOverHandler(type);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/cart/cart.component.ts